export enum AsEnteredPartyIndex {
  Claimant = 0,
  Payee = 1,
}
